import { makeStyles } from '@material-ui/core';
import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/Shared/Modal';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  modal: {
    minWidth: 1000,
  },
  loaderStyle: {
    minHeight: 500,
  },
  createButton: {
    marginRight: theme.spacing(2),
  },
}));

const CreateProgramModal = ({ open, handleClose, accountUuid, patientUuid }) => {
  const classes = useStyles();
  const { en: { errors, notifications, titles, btn } } = useSelector((state) => state.i18n);
  const [backendErrors, setBackendErrors] = useState({});
  const closeModal = (hasThePatientBeenUpdated) => {
    handleClose(hasThePatientBeenUpdated);
    // setBackendErrors({});
    // setPatient(null);
  };
  // const [patient, setPatient] = useState();
  // const dispatch = useDispatch();
  // const { user } = useSelector((state) => state.user);
  // const { setPatientInfo } = useContext(ActivePatientContext);
  // const [isSuccess, setIsSuccess] = useState(false);
  // const [isFailed, setIsFailed] = useState(false);
  //
  // const { query } = useMetadataUpdate(useQuery, [
  //   {
  //     method: 'GET',
  //     endpoint: `/accounts/${accountUuid}/patients/${patientUuid}`,
  //   },
  //   false,
  // ]);
  //
  // useEffect(() => {
  //   if (open && query) {
  //     query().then(({ error, payload }) => {
  //       if (!error) {
  //         setPatient(payload);
  //       }
  //     });
  //   }
  // }, [query, open]);
  //
  // const patientEditAction = (patches) => ({
  //   method: 'PATCH',
  //   endpoint: `/accounts/${accountUuid}/patients/${patientUuid}`,
  //   body: patches,
  // });
  // const { loading, mutate } = useMetadataUpdate(useMutation, [
  //   patientEditAction,
  // ]);
  //
  // const editPatient = async (values, { setSubmitting }) => {
  //   const patches = compare(
  //     {
  //       ...patient,
  //       phone: {
  //         phone: patient.phone,
  //       },
  //     },
  //     {
  //       ...values,
  //       dateOfBirth: values.dateOfBirth.includes('Z')
  //         ? values.dateOfBirth
  //         : getUtcDate(values.dateOfBirth),
  //       phone: {
  //         phone: getDigitPhone(values.phone),
  //       },
  //     },
  //   );
  //
  //   if (patches.length) {
  //     setBackendErrors({});
  //     const { payload, error, status } = await mutate(patches);
  //     if (error) {
  //       setIsFailed(true);
  //       setTimeout(() => {
  //         setIsFailed(false);
  //       }, 2000);
  //       const options = payload && {
  //         correlationUUID: payload.correlationUUID,
  //         userUUID: user.uuid,
  //       };
  //       switch (status) {
  //         case 422: {
  //           showServerError(dispatch, errors.validationError);
  //           setBackendErrors(payload.validationErrors);
  //           break;
  //         }
  //         default: {
  //           showServerError(dispatch, '', options);
  //           break;
  //         }
  //       }
  //     } else if (payload) {
  //       setIsSuccess(true);
  //       setTimeout(() => {
  //         setIsSuccess(false);
  //       }, 2000);
  //       setPatient(payload);
  //       setPatientInfo({
  //         ...payload,
  //         dateOfBirth: getLocalizedDate(patient.dateOfBirth, 'UTC'),
  //         phone: formatPhoneNumber(
  //           payload.phone != null ? payload.phone.phone : '',
  //         ),
  //       });
  //       closeModal(true);
  //       dispatch(
  //         enqueueSnackbar({
  //           message: getTransitionWithVariable(notifications.patientEdited, {
  //             name: getFullName(values),
  //           }),
  //           options: {
  //             variant: SNACKBAR_VARIANTS.success,
  //           },
  //         }),
  //       );
  //     }
  //     setSubmitting(false);
  //   }
  // };

  return (
    <Modal
      open={open}
      classes={{ paper: classes.modal }}
      title={titles.createProgram}
      handleClose={() => closeModal(false)}
    >
      {'TEST CONTENT'}


      {/*{*/}
      {/*  !patient && <Loader*/}
      {/*    fullHeight*/}
      {/*    className={classes.loaderStyle}*/}
      {/*  />*/}
      {/*}*/}
      {/*{patient && <Formik*/}
      {/*  initialValues={{*/}
      {/*    ...patient,*/}
      {/*    phone: conformToMask(get(patient, 'phone.phone', ''), MASK)*/}
      {/*      .conformedValue,*/}
      {/*  }}*/}
      {/*  validateOnBlur={false}*/}
      {/*  enableReinitialize*/}
      {/*  onSubmit={editPatient}*/}
      {/*>*/}
      {/*  {({ isValid, isSubmitting, dirty, handleSubmit, values }) => (*/}
      {/*    <Box p={4}>*/}
      {/*      <PatientForm*/}
      {/*        values={values}*/}
      {/*        backendErrors={backendErrors}*/}
      {/*        actions={*/}
      {/*          <Box py={2} display='flex' justifyContent='space-between'>*/}
      {/*            <RoundedButton*/}
      {/*              variant='outlined'*/}
      {/*              color='primary'*/}
      {/*              size='small'*/}
      {/*              onClick={() => closeModal(false)}*/}
      {/*              className={classes.createButton}*/}
      {/*            >*/}
      {/*              {btn.cancel}*/}
      {/*            </RoundedButton>*/}
      {/*            <RoundedButton*/}
      {/*              variant='contained'*/}
      {/*              color='primary'*/}
      {/*              size='small'*/}
      {/*              disabled={!isValid || isSubmitting || !dirty}*/}
      {/*              onClick={handleSubmit}*/}
      {/*              isLoading={loading}*/}
      {/*              isSuccess={isSuccess}*/}
      {/*              isFailed={isFailed}*/}
      {/*              className={classes.createButton}*/}
      {/*            >*/}
      {/*              {btn.save}*/}
      {/*            </RoundedButton>*/}
      {/*          </Box>*/}
      {/*        }*/}
      {/*      />*/}
      {/*    </Box>*/}
      {/*  )}*/}
      {/*</Formik>}*/}
    </Modal>
  );
};

CreateProgramModal.propTypes = {
  open: PropTypes.bool.isRequired,
  patientUuid: PropTypes.string.isRequired,
  accountUuid: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default CreateProgramModal;
